import { Box, Grid } from '@mui/material';
import Input from 'Components/FormControls/Input';
import SwitchToggle from 'Components/FormControls/SwitchToggle';
import { showAlertMessage } from 'Features/alertMessage/alertMessageSlice';
import { t } from 'i18next';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';

const ApproverEmailForm = ({ isEditing }) => {
  const { control, setValue, trigger } = useFormContext();
  const dispatch = useDispatch();

  const secondApprover = useWatch({ control, name: 'secondApprover' });
  const thirdApprover = useWatch({ control, name: 'thirdApprover' });

  const handleSecondApproverChange = async () => {
    if (!secondApprover) {
      const isPrimaryApproverNameValid = await trigger('approverName');
      const isPrimaryApproverEmailValid = await trigger('approverEmail');

      if (!isPrimaryApproverNameValid || !isPrimaryApproverEmailValid) {
        setValue('secondApprover', false);
        return;
      }
    }

    if (secondApprover && thirdApprover) {
      setValue('secondApprover', true);
      dispatch(
        showAlertMessage({
          type: 'error',
          text: t('approverManagement.errors.secondApproverToggle')
        })
      );
      return;
    }

    setValue('secondApprover', !secondApprover);
    setValue('secondApproverName', '');
    setValue('secondApproverEmailAddress', '');
  };

  const handleThirdApproverChange = async () => {
    if (!thirdApprover) {
      const isSecondApproverNameValid = await trigger('secondApproverName');
      const isSecondApproverEmailValid = await trigger('secondApproverEmailAddress');

      if (!isSecondApproverNameValid || !isSecondApproverEmailValid) {
        setValue('thirdApprover', false);
        return;
      }
    }

    setValue('thirdApprover', !thirdApprover);
    setValue('thirdApproverName', '');
    setValue('thirdApproverEmailAddress', '');
  };

  return (
    <Box className="add-section-approver">
      <Grid container spacing={2} columnSpacing={2} className="input-group-container mb-2">
        <Grid item xs={12} className="input-container">
          <Grid container spacing={2} columnSpacing={2} className="switchToggleBox">
            <Grid item xs={12} sm={6}>
              <SwitchToggle
                id="secondApprover"
                name="secondApprover"
                label={t('approverManagement.secondApprover')}
                defaultChecked={secondApprover || false}
                onChangeValue={handleSecondApproverChange}
                disabled={isEditing}
              />
            </Grid>
          </Grid>
          {secondApprover && (
            <Grid
              container
              spacing={2}
              columnSpacing={2}
              className="input-group-container padding20">
              <Grid item xs={12} sm={6}>
                <Input
                  name="secondApproverName"
                  label={t('approverManagement.secondApproverName')}
                  placeholder={t('approverManagement.secondApproverName')}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Input
                  name="secondApproverEmailAddress"
                  label={t('approverManagement.secondApproverEmailAddress')}
                  placeholder={t('form.email')}
                  required
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={2} columnSpacing={2} className="input-group-container mb-2">
        <Grid item xs={12} className="input-container">
          <Grid container spacing={2} columnSpacing={2} className="switchToggleBox">
            <Grid item xs={12} sm={6}>
              <SwitchToggle
                id="thirdApprover"
                name="thirdApprover"
                label={t('approverManagement.thirdApprover')}
                defaultChecked={thirdApprover || false}
                onChangeValue={handleThirdApproverChange}
                disabled={!secondApprover || isEditing}
              />
            </Grid>
          </Grid>
          {thirdApprover && (
            <Grid
              container
              spacing={2}
              columnSpacing={2}
              className="input-group-container padding20">
              <Grid item xs={12} sm={6}>
                <Input
                  name="thirdApproverName"
                  label={t('approverManagement.thirdApproverName')}
                  placeholder={t('approverManagement.thirdApproverName')}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Input
                  name="thirdApproverEmailAddress"
                  label={t('approverManagement.thirdApproverEmailAddress')}
                  placeholder={t('form.email')}
                  required
                />
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApproverEmailForm;
